import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RoleMatrixComponent } from './role-matrix.component'
import { ConfigModule, I18nModule } from '@spartacus/core'
import { environment } from '../../../../../../environments/environment'

@NgModule({
  declarations: [RoleMatrixComponent],
  imports: [
    CommonModule,
    I18nModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['myProfile'],
        },
      },
    }),
  ],
  exports: [RoleMatrixComponent],
})
export class RoleMatrixModule {}
